import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

export default function ThemeToggle({ size = 18, testId = "theme-toggle" }) {
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      data-testid={testId}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? "Cambiar a claro" : "Cambiar a oscuro"}
      title={isDark ? "Cambiar a claro" : "Cambiar a oscuro"}
      className="p-2 rounded-full hover:opacity-70 transition relative overflow-hidden"
      style={{ color: "var(--text)" }}
    >
      <span
        className="block transition-transform duration-500"
        style={{ transform: isDark ? "rotate(0deg)" : "rotate(180deg)" }}
      >
        {isDark ? <Moon size={size} strokeWidth={2.2} /> : <Sun size={size} strokeWidth={2.2} />}
      </span>
    </button>
  );
}
